import type { Document, DocumentCreate } from '@quromedical/models';
import { trpcClient } from 'trpc';

export class DocumentApi {
  createDocument = async (document: DocumentCreate): Promise<Document> => {
    return trpcClient.document.create.mutate(document);
  };

  getDownloadURL = async (id: string): Promise<string> => {
    return trpcClient.document.getDownloadURL.query({ id });
  };
}
